import { length } from 'stringz';

export const CharacterCounter: React.FC<{
  text: string;
  max: number;
  isComposeForm?: boolean
}> = ({ text, max, isComposeForm }) => {
  const diff = max - length(text);

  if (diff < 0) {
    return (
      <span className={`character-counter character-counter--over ${isComposeForm && 'compose__form--character'}`}>{diff}</span>
    );
  }

  return <span className={`character-counter ${isComposeForm && 'compose__form--character'}`}>{diff}</span>;
};
